$(document).ready(function(){$(".video-ply-button").click(function(){$("#video-popup1").show(),$("body").addClass("popup-open");var t=$(this).attr("data-video-url"),o=$(this).attr("data-button-link"),i=$(this).attr("data-button-text");$("#video-iframe-slider").attr("src",t),$(".video-product-link").text(i),$(".video-product-link").attr("href",o)}),$("#close-button1").click(function(){$("#video-popup1").hide(),$("body").removeClass("popup-open")})});

$(document).ready(function(){$(".video-ply-button1").click(function(){$("#video-popup1").show(),$("body").addClass("popup-open");var o=$(this).attr("data-video-url-slider");$("#video-iframe-slider").attr("src",o)}),$("#close-button").click(function(){$("#video-popup").hide(),$("body").removeClass("popup-open")})});

$(document).ready(function(){null==sessionStorage.getItem("dontLoad")&&($(".varification-popup").css("display","none"),$("body").addClass("site-popup-close"),$(".varification-popup").show(),sessionStorage.setItem("dontLoad","true")),$(".popup-close").click(function(){$(".varification-popup").hide(),$(".site-popup-main-section").removeClass("in"),$("body").removeClass("site-popup-close")})});


// Product Page


$(".product-form__submit").click(function(){setTimeout(function(){$("body").toggleClass("overflow-hidden")},1500)});



$(document).ready(function() {
    // Show or hide the "Back to Top" button
    $(window).scroll(function() {
        if ($(this).scrollTop() > 300) {
            $('#back-to-top').fadeIn();
        } else {
            $('#back-to-top').fadeOut();
        }
    });

    // Smooth scroll to top
    $('#back-to-top').click(function() {
        $('html, body').animate({scrollTop : 0}, 800);
        return false;
    });
});



document.addEventListener('DOMContentLoaded', function () {
    // Select all thumbnail buttons
    const thumbnailButtons = document.querySelectorAll('.product .thumbnail');

    thumbnailButtons.forEach(button => {
        button.addEventListener('click', function () {
            // Pause all videos when a thumbnail is clicked
            const allVideos = document.querySelectorAll('video');

            allVideos.forEach(video => {
                if (!video.paused) {
                    video.pause(); // Pause the video if it's playing
                }
            });
        });
    });
});